import React, { useEffect, useRef, useContext, useState } from 'react';
import { DefaultContext } from '../../../context/context_default';

const CardItem = ({ item, onHover, onLeave, isPreviewMode = true, quebrador = false }) => {
	const [card, setCard] = useState(null);
	const itemRef = useRef(null);
	const { listCards, tipos, raridades, is_descktop } = useContext(DefaultContext);

	useEffect(() => {
		if (listCards && item?.id) {
			const foundCard = listCards.find(c => c.id === item.id);
			setCard(foundCard);
		}
	}, [item, listCards]);

	const handleMouseEnter = (e) => {
		if (isPreviewMode && card && onHover) {
			onHover(card, { x: e.clientX, y: e.clientY });
		}
	};

	const handleMouseMove = (e) => {
		if (isPreviewMode && card && onHover) {
			onHover(card, { x: e.clientX, y: e.clientY });
		}
	};

	const handleMouseLeave = () => {
		if (onLeave) {
			onLeave();
		}
	};

	if (!card) {
		return (
			// <div className="w-full h-8 bg-slate-800 border border-slate-600 rounded animate-pulse">
			// 	<div className="flex items-center h-full px-2">
			// 		<div className="w-4 h-4 bg-slate-700 rounded-full mr-2"></div>
			// 		<div className="flex-1 h-3 bg-slate-700 rounded"></div>
			// 	</div>
			// </div>
			null
		);
	}

	const getCostColor = (cost) => {
		if (cost === 0) return 'bg-gray-500 text-white';
		if (cost <= 2) return 'bg-green-500 text-white';
		if (cost <= 4) return 'bg-yellow-500 text-black';
		if (cost <= 6) return 'bg-orange-500 text-white';
		return 'bg-red-500 text-white';
	};

	const getRarityColor = (raridadeId) => {
		const raridadeObj = raridades?.find(r => r.id === raridadeId);
		const raridadeNome = raridadeObj?.raridade?.toLowerCase();

		switch (raridadeNome) {
			case 'comum': return 'border-l-orange-400';
			case 'incomum': return 'border-l-gray-400';
			case 'rara': return 'border-l-yellow-400';
			case 'lendária': return 'border-l-purple-400';
			default: return 'border-l-slate-400';
		}
	};

	const getTipoNomes = (tipoIds) => {
		if (!Array.isArray(tipoIds)) return '';
		return tipoIds.map(tipoId => {
			const tipoObj = tipos?.find(t => t.id === tipoId);
			return tipoObj?.tipo || `Tipo ${tipoId}`;
		}).join(', ');
	};

	return (
		<div
			ref={itemRef}
			className={`w-full group transition-all duration-200  ${isPreviewMode ? 'cursor-pointer' : ''} ${quebrador ? 'transform scale-[1.02]' : ''
				}`}
			onMouseEnter={handleMouseEnter}
			onMouseMove={handleMouseMove}
			onMouseLeave={handleMouseLeave}
			onClick={() => {
				window.open(`/detail/${card.id}`, '_blank');
			}}
		>
			<div className={`
        relative overflow-hidden rounded-lg border-l-4 ${getRarityColor(card.raridade)}
        bg-gradient-to-r from-slate-800 to-slate-700
        border border-slate-600 hover:border-slate-500
        shadow-sm hover:shadow-md transition-all duration-200
        ${quebrador ? 'border-2 border-yellow-400 shadow-lg shadow-yellow-400/20 bg-gradient-to-r from-yellow-900/30 to-slate-700' : ''}
      `}>
				{/* Background da carta (sutil) */}
				{card.url_img && (
					<div
						className={`absolute inset-0 bg-cover bg-center ${quebrador ? 'opacity-40' : 'opacity-20'
							}`}
						style={{
							backgroundImage: `url(${card.url_img})`,
							backgroundPosition: 'center',
							backgroundPositionY: quebrador ? is_descktop ? -260 : -100 : (card.deckTipo === '0' || !card.deckTipo) ? -100 : -270,
							backgroundSize: quebrador ? is_descktop ? '120%' : '150%' : '130%'
						}}
					/>
				)}

				<div className={`relative flex items-center p-2 ${quebrador ? 'min-h-[10rem] p-3' : 'min-h-[2rem]'
					}`}>
					{/* Custo de mana */}
					{card.custo !== undefined && card.deckTipo === '0' && (
						<div className={`
              flex items-center justify-center w-6 h-6 rounded-full text-xs font-bold mr-2
              ${getCostColor(parseInt(card.custo))}
              shadow-sm
            `}>
							{card.custo}
						</div>
					)}

					{/* Nome da carta */}
					<div className="flex-1 min-w-0">
						<h4 className={`font-medium truncate group-hover:text-white transition-colors ${quebrador ? 'text-yellow-200 text-base font-bold' : 'text-slate-200 text-sm'
							}`}>
							{card.nome}
						</h4>
						{card.tipo && (
							<p className={`truncate ${quebrador ? 'text-yellow-300 text-sm font-medium' : 'text-slate-400 text-xs'
								}`}>
								{getTipoNomes(card.tipo)}
							</p>
						)}
					</div>

					{/* Quantidade */}
					{item.qtd && (
						<div className="ml-2">
							<span className={`
                inline-flex items-center justify-center rounded-lg font-semibold
                transition-colors duration-200
                ${quebrador
									? 'w-8 h-8 bg-yellow-600 hover:bg-yellow-500 border border-yellow-400 text-yellow-100 text-sm'
									: 'w-6 h-6 bg-slate-600 hover:bg-slate-500 border border-slate-500 text-slate-200 text-xs'
								}
              `}>
								x{item.qtd}
							</span>
						</div>
					)}
				</div>

				{/* Indicador de hover */}
				<div className={`absolute inset-0 opacity-0 group-hover:opacity-5 transition-opacity duration-200 pointer-events-none ${quebrador ? 'bg-yellow-400' : 'bg-blue-500'
					}`} />

				{/* Indicador especial para quebrador */}
				{quebrador && (
					<div className="absolute top-1 right-1 w-3 h-3 bg-yellow-400 rounded-full animate-pulse" />
				)}
			</div>
		</div>
	);
};

export default CardItem;